import React, { useState, useEffect, useRef } from "react";
import { Fab, Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerInput } from "rc-datepicker";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import { Link } from "react-router-dom";
import Modal_Frame from "../biztran_controls/Modal_Frame";
import Moment from "moment";
import UseFetchData from "../../hooks/UseFetchData";
import BiztranControls from "../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";
import Data_Grid from "../biztran_controls/DataGrid";
import { Spacing } from "@material-ui/core/styles/createSpacing";
import CreateSerialNumber from "./CreateSerialNumber";
import { BASE_URL } from "../../Global";
import Cecertificate from "./CustomerPage";
import AddMultipleSerialNo from "./AddMultipleSerialNo";
//import AddExpenseSheet from "./AddExpenseSheet";
//const todate = new Date()



const CreateMfgBatch = (props) => {
    const [Mode, setMode] = useState("");
    const [isOpen, setOpen] = useState(false);
    const [Count, setCount] = useState();
    const [LinkVisible, setLinkVisible] = useState(false);
    const [isOpenMultiple, setOpenMultiple] = useState(false);
    const [rows1, setRows1] = useState([]);
    const [columns1, setColumns1] = useState([]);
    const [ModelName, setModelName] = useState('');
    const [SerialNumber, setSerialNumber] = useState('');
    const [MfgBatchSerialNoID, setMfgBatchSerialNoID] = useState('');
    const [Modelcmb, setModelcmb] = useState([]);
    const [MfgBatchID, setMfgBatchID] = useState('');
    const [MfgBatchNo, setMfgBatchNo] = useState('');
    const [MfgDate, setMfgDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [ModelID, setModelID] = useState('');
    const [MfgQty, setMfgQty] = useState('');
    const [Remarks, setRemarks] = useState('');
    const [CreatedByID, setCreatedByID] = useState(sessionStorage.UserName);
    const [CreatedOn, setCreatedOn] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [response, fetchData] = UseFetchData();
    const [responseqr, fetchQRData] = UseFetchData();
    const [responseQRUnpacking, fetchQRUnpacking] = UseFetchData();
    const [responseCEPath, fetchCEPath] = UseFetchData('');
    const [response1, fetchData1] = UseFetchData();
    const [responseCombo, fetchComboData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData('');
    // const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);

    const onSubmit = values => {
        var bodyFormData = new FormData();
        bodyFormData.append("MfgBatchID", props.MfgBatchID);
        bodyFormData.append("MfgBatchNo", values.MfgBatchNo);
        bodyFormData.append("MfgDate", values.MfgDate);
        bodyFormData.append("ModelID", values.ModelID);
        bodyFormData.append("MfgQty", values.Count);
        bodyFormData.append("Remarks", values.Remarks);
        bodyFormData.append("CreatedByID", values.CreatedByID);
        bodyFormData.append("CreatedOn", values.CreatedOn);
        fetchData("MfgBatch/Save", bodyFormData);
    }

    const handleOpenModal = () => {
        setMfgBatchSerialNoID('');
        setOpen(true);
    };

    const handleOpenModalMultiple = () => {
        setMfgBatchSerialNoID('');
        setOpenMultiple(true);
    };

    const generateQRCode = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("ModelID", ModelID);
        bodyFormData.append("MfgBatchID", MfgBatchID);
        bodyFormData.append("MfgDate", Moment(MfgDate).format("DD/MM/YYYY"));
        fetchQRData("MfgBatch/GenerateQRCode", bodyFormData);
    }

    const QRCodeUnpacking = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("ModelID", ModelID);
        bodyFormData.append("MfgBatchID", MfgBatchID);
        bodyFormData.append("MfgDate", Moment(MfgDate).format("DD/MM/YYYY"));
        fetchQRUnpacking("MfgBatch/QRCodeUnpacking", bodyFormData);
    }

    const openModal = (params) => {
        debugger;
        setMode("Update");
        setMfgBatchSerialNoID(props.MfgBatchID);
        // setOpen(true);
        if (params !== undefined) {
            ;
            setMfgBatchSerialNoID(params.id);
            setOpen(true);
        } else {
            setMfgBatchSerialNoID('');
            setOpen(true);
        }
        // setOpen(true);
        // setMfgBatchSerialNoID(row.id);

    };


    const PopulateModelData = () => {
        var bodyFormData = new FormData();
        //bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        fetchComboData("MfgBatch/ModelList", bodyFormData);
    }

    const ModelData = (options) => {
        if (options !== undefined) {
            let Type = options.map((data) => (
                <option key={data.ModelCode} value={data.ModelID}>
                    {data.ModelCode}
                </option>
            ));
            setModelcmb(Type);
        }
    };

    const openpath = (row) => {
        debugger;
        //setOpen(true);
        var bodyFormData = new FormData();
        bodyFormData.append("ModelID", ModelID);
        bodyFormData.append("SerialNo", row.formattedValue);
        fetchCEPath("MfgBatch/GenerateCECertificate", bodyFormData);
        //window.open("/Files/CECertificate/CECertificate.pdf");

        //console.log(row.UserManual);
    };

    const openCustomerPage = (row) => {
        debugger;
        //window.open(BASE_URL + "CustomerPage?SerialNo=" + row.formattedValue + "&ModelID=" + ModelID);
        window.open(BASE_URL + "CustomerPage?SerialNo=" + row.formattedValue, '_blank', 'noopener,noreferrer');
    };




    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("MfgBatchID", props.MfgBatchID);
        bodyFormData.append("MfgBatchNo", MfgBatchNo);
        bodyFormData.append("MfgDate", MfgDate);
        fetchGetData("MfgBatch/GetByID", bodyFormData);
    }

    const PopulateMData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("SerialNumber", SerialNumber);
        bodyFormData.append("MfgBatchID", props.MfgBatchID);
        fetchData1("MfgBatch/Seriallist", bodyFormData);
    }

    useEffect(() => {

        if (responseGetData.length > 0) {
            setMfgBatchNo(responseGetData[0].MfgBatchNo);
            setMfgQty(responseGetData[0].Count);
            setRemarks(responseGetData[0].Remarks);
            setMfgDate((responseGetData[0].MfgDate === null) ? "" : Moment(responseGetData[0].MfgDate).format('YYYY-MM-DD'));
            setModelID((responseGetData[0].ModelID === null) ? "" : responseGetData[0].ModelID);

        }
    }, [responseGetData])

    useEffect(() => {
        debugger;
        if (response.Response === true) {
            alert('Data Saved Succesfully.');
            props.PopulatebData();
            props.setOpen(false);
        }
        else if (response.Response === false) {
            if (response.Message.includes('Already') === true) {
                alert(response.Message);
            }
            else {
                alert('Failed.');
            }
        }
        if (response.length > 0 && Mode === 'Update') {
            setMfgBatchNo(response[0].MfgBatchNo);
            setMfgQty(response[0].Count);
            setRemarks(response[0].Remarks);
            setMfgDate((response[0].MfgDate === null) ? "" : Moment(response[0].MfgDate).format('YYYY-MM-DD'));
            setModelID((response[0].ModelID === null) ? "" : response[0].ModelID);

        }
    }, [response]);




    useEffect(() => {
        PopulateModelData();
        ModelData();
        console.log(props.MfgBatchID);
        setMfgBatchID(props.MfgBatchID);
        if (props.Mode === "Insert") {
            setLinkVisible(true);
        }
    }, [])

    useEffect(() => {
        if (responseCombo !== undefined && responseCombo.length > 0) {
            ModelData(responseCombo);
        }

    }, [responseCombo]);

    useEffect(() => {
        debugger;
        if (responseqr.Response === true) {
            console.log(responseqr)
            window.open("/Files/QRcode/QR.pdf");
            //console.log(BASE_URL + "/Files/QRcode/" + responseqr)
        }
    }, [responseqr]);

    useEffect(() => {
        debugger;
        if (responseCEPath.Response === true) {
            //console.log(responseCEPath)
            window.open("/Files/CECertificate/CECertificate.pdf");
            //console.log("/Files/QRcode/" + responseCEPath);
        }
    }, [responseCEPath]);

    useEffect(() => {
        debugger;
        if (responseQRUnpacking.Response === true) {
            console.log(responseQRUnpacking)
            window.open("/Files/QRcode/QRUnpacking.pdf");
            //console.log(BASE_URL + "/Files/QRcode/" + responseqr)
        }
    }, [responseQRUnpacking]);

    useEffect(() => {
        const gridCols = [
            // {
            //     field: "id",
            //     headerName: "Select",
            //     //renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
            //     //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 120,
            // },
            {
                field: "id",
                headerName: ".",
                // renderCell: (params) => (<strong> <Link to={{ pathname: "/Employeemaster/CallRegistrationView", state: { CallID: params.id } }} style={{ color: 'blue' }} >View</Link> </strong>),
                renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Edit</a> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 10,
            },
            {
                field: "SerialNumber",
                headerName: "Serial Number",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 340,
            },
            // {
            //     field: "SerialNo",
            //     headerName: "Print CE Certificate",
            //     renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openpath(params); }} >Download</a> </strong>),
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 250,
            // },
            {
                field: "SENo",
                headerName: "View Customer Page",
                renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openCustomerPage(params); }} >View</a> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 500,
            },


        ];
        setColumns1(gridCols);
        setRows1(response1);
        setCount(response1.length);
    }, [response1]
    );

    useEffect(() => {
        debugger;
        getByIDData();

    }, [])

    useEffect(() => {
        PopulateMData();
    }, [])

    return (
        <div>

            <Formik initialValues={{
                MfgBatchNo: MfgBatchNo, MfgDate: MfgDate, ModelName: ModelName, ModelID: ModelID, Count: Count,
                MfgQty: MfgQty, Remarks: Remarks, CreatedByID: CreatedByID, CreatedOn: CreatedOn
            }}
                onSubmit={onSubmit}
                enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid item xs={12} spacing={1} container rowSpacing={1} direction="row">
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"MfgBatchNo"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Mfg.Batch No"}
                                </label>
                            </Grid>
                            <Grid item xs={4} >
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="MfgBatchNo"
                                    //ref={ref}
                                    value={MfgBatchNo}
                                    //options={ASIcmb}
                                    disabled={true}
                                    onChange={(e) => {
                                        setMfgBatchNo(e.target.value)
                                        //handleChange()
                                    }}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <label
                                    htmlFor={"MfgDate"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Mfg Date"}
                                </label>
                            </Grid>
                            <Grid item xs={4} >
                                <div style={{ width: "295px", marginTop: -1 }}>
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="date"
                                        name="MfgDate"
                                        //ref={ref}
                                        // value={MfgBatchNo}
                                        //options={ASIcmb} 
                                        disabled={false}
                                        onChange={(e) => {
                                            setMfgDate(e.target.value)
                                            //handleChange()
                                        }}

                                    />
                                </div>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} spacing={1} container rowSpacing={1} direction="row" >
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"ModelID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Model No"}
                                </label>
                            </Grid>
                            <Grid item xs={4} >
                                <div style={{ width: "125%", marginLeft: -1, marginTop: 2 }} >
                                    <div style={{ float: "left", marginTop: 0, width: "80%" }}>
                                        <BiztranControlsFormik
                                            autoFocus="autofocus"
                                            control="select"
                                            type="text"
                                            name="ModelID"
                                            // ref={ref}
                                            // value={Branch}
                                            options={Modelcmb}
                                            // disabled={true}
                                            onChange={(e) => {
                                                setModelID(e.target.value)
                                            }}
                                        />
                                        {/* <BiztranControls.Select

                                            //label="Model Name"
                                            id="ModelName"
                                            name = "ModelName"
                                            width={"520px"}
                                            options={Modelcmb}
                                            onChange={(e) => setModelID(e.target.value)}
                                        /> */}
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"MfgQty"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Mfg. Qty"}
                                </label>
                            </Grid>
                            <Grid item xs={4} >
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="MfgQty"
                                    //ref={ref}
                                    value={Count}
                                    disabled={true}
                                    //options={ASIcmb}                   
                                    onChange={(e) => {
                                        setCount(e.target.value)
                                        //handleChange()
                                    }}
                                />
                            </Grid>
                        </Grid>

                        {/* <Grid item xs={12} spacing={1} container rowSpacing={1} direction="row" >

                        </Grid> */}

                        <Grid item xs={12} spacing={1} container rowSpacing={1} direction="row" >
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"Remarks"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Remarks"}
                                </label>
                            </Grid>
                            <Grid item xs={10}>
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control="textarea"
                                    type="text"
                                    name="Remarks"
                                    //ref={ref}
                                    value={Remarks}
                                    //options={ASIcmb}                   
                                    onChange={(e) => {
                                        setRemarks(e.target.value)
                                        //handleChange()
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={10} spacing={1} container rowSpacing={1} direction="row" >
                            <a href="javascript:;" style={{ marginLeft: 5 }} onClick={() => { handleOpenModal(); }} hidden={LinkVisible}> Add </a>
                            <a href="javascript:;" style={{ marginLeft: 10 }} onClick={() => { handleOpenModalMultiple(); }} hidden={LinkVisible}> Add Multiple </a>
                        </Grid>
                        {/* <br /> */}

                        <Grid item xs={10} style={{ marginTop: 10 }}>
                            <BiztranControls.DataGrid
                                rowHeight={25}
                                headerHeight={34}
                                rows={rows1}
                                columns={columns1}
                                checkboxSelection={false}
                                // autoHeight={true}
                                Width="120%"
                                Height="250px"
                                hideFooter={true}
                            />
                        </Grid>
                        <br />
                        <Grid item xs={12} spacing={1} container rowSpacing={1} direction="row">
                            <Grid item xs={2}>
                                <div >
                                    <label
                                        htmlFor={"CreatedByID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Created By"}
                                    </label>
                                </div>
                            </Grid>
                            <Grid item xs={4} >
                                <div >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="CreatedByID"
                                        //ref={ref}
                                        disabled={true}
                                        value={CreatedByID}
                                        //options={ASIcmb}                   
                                        onChange={(e) => {
                                            setCreatedByID(e.target.value)
                                            //handleChange()
                                        }}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={2}>
                                <div >
                                    <label
                                        htmlFor={"CreatedOn"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Created On "}
                                    </label>
                                </div>

                            </Grid>
                            <Grid item xs={4} >
                                <div >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="Created On"
                                        //ref={ref}
                                        value={CreatedOn}
                                        // options={Branchcmb}
                                        disabled={true}
                                        onChange={(e) => {
                                            setCreatedOn(e.target.value)
                                            //handleChange()
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                        {/* <br></br> */}
                        <Grid item xs={12}>
                            <div style={{ width: '100%' }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignContent: "center"
                                }}>
                                    <BiztranControls.Button
                                        text="UPDATE"
                                        type="submit"
                                        startIcon={<SaveIcon />}
                                    />
                                    <BiztranControls.Button
                                        text="QR Code-Unpacking Manual"
                                        //type="submit"
                                        onClick={QRCodeUnpacking}
                                        style={{ width: "25%" }}
                                    //startIcon={<SaveIcon />}
                                    />
                                    <BiztranControls.Button
                                        text="QR Code-Download Docs"
                                        //type="submit"
                                        onClick={generateQRCode}
                                        style={{ width: "25%" }}
                                    // startIcon={<SaveIcon />}
                                    />
                                    {/* <BiztranControls.Button
                    text="CLOSE"
                    startIcon={<CloseIcon />}
                    onClick={() => { props.setOpen(false); }}
                  /> */}
                                </div>
                            </div>
                        </Grid>

                        {/* <Grid container="row"  spacing={2}  rowSpacing={1}>
                        <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
                        <div style={{ width: "110%", marginLeft: 3, marginTop: -20 }} >
                                    <div style={{ float: "left", marginTop: 0, width: "40%" }}>
                                        <BiztranControls.Button
                                            text="QR Code-Download Docs"
                                            type="submit"
                                            style={{  width: "30%" }}
                                        //startIcon={<SaveIcon />}
                                        />
                                    </div>
                                </div>
                            </Grid>
                            </Grid> */}

                    </Form>
                }}
            </Formik>
            <Modal_Frame
                title="Add/Edit Service Engineer"
                maxWidth="xs"
                isOpen={isOpen}
                setOpen={setOpen}
            >
                <CreateSerialNumber
                    MfgBatchID={MfgBatchID}
                    MfgBatchSerialNoID={MfgBatchSerialNoID}
                    setOpen={setOpen}
                    PopulateMData={PopulateMData}
                />

            </Modal_Frame>
            <Modal_Frame
                title="Add/Edit Multiple Serial No"
                maxWidth="xs"
                isOpen={isOpenMultiple}
                setOpen={setOpenMultiple}
            >
                <AddMultipleSerialNo
                    MfgBatchID={MfgBatchID}
                    MfgBatchSerialNoID={MfgBatchSerialNoID}
                    setOpen={setOpenMultiple}
                    PopulateMData={PopulateMData}
                />

            </Modal_Frame>

        </div>
    )
}

export default CreateMfgBatch;